module.exports = __webpack_public_path__ + "img/function_0_param_1_result.086cc992.png";